import { getStorage } from "./storage";
export { default as deepClone } from "./deepClone";
/**
 * @description: 检测输入的分数精度
 * @param {number | string} val 当前输入值
 * @param {number} max 输入值上限
 * @param {number} len 保留几位小数
 * @param {boolean} canZero 是否可以取0
 * @return: string
 */
export function numLimitCheck(val, max, len, canZero) {
  if (!len && typeof len == "number") {
    //判断是0不是空，len为0时则表示限制输入为大于零的正整数
    if (canZero) {
      val = val.replace(/[^\d]+/, "");
      if (val.length > 1 && val.substr(0, 1) == 0) {
        return (val = "0");
      }
    } else {
      val = val.replace(/^0|[^\d]+/, "");
    }

    if (val > max) {
      let valLen = val.length;
      for (var i = valLen - 1; i >= 0; i--) {
        let subVal = val.substr(0, i);
        if (subVal <= max) {
          return subVal;
        }
      }
    } else {
      return val;
    }
  }

  var saveLen = len ? len + 1 : 2;
  val = String(val).replace(/[^\d.]/g, "");
  var point = val.indexOf(".");
  if (point != -1) {
    var cutlen =
      val.indexOf("..") != -1 ? point + saveLen - 1 : point + saveLen;
    val = val.slice(0, cutlen);
  }
  if (val > max) {
    var valLen = val.length;
    for (let i = valLen - 1; i >= 0; i--) {
      var subVal = val.slice(0, i);
      if (subVal <= max) {
        return subVal;
      }
    }
  } else if (val.slice(0, 1) === "0" && val.slice(1, 2).indexOf(".") != -1) {
    let patrn = /^[0]{1}(\.\d?)?$/;
    if (!patrn.exec(val)) {
      let a2 = val.slice(0, val.length);
      return a2;
    } else {
      return val;
    }
  } else if (val.slice(0, 1) === "0" && val.slice(1, 2).indexOf(".") == -1) {
    let patrn = /^[0]{1}(\.\d?)?$/;
    if (!patrn.exec(val)) {
      let a2 = val.slice(0, val.length - 1);
      return a2;
    } else {
      return val;
    }
  } else {
    let patrn = /^[1-9]\d*(\.\d?)?$/;
    if (!patrn.exec(val)) {
      if (val.length > 1) {
        let a1 = val.slice(0, val.length);
        return a1;
      } else {
        return val;
      }
    } else {
      return val;
    }
  }
}

/**
 * @description 检查日期格式是否正确
 * @param {(Date|Number|String)} date - new Date() | new Date().getTime() | '2020-10-10'
 * @returns {boolean}
 */
export function checkDate(date) {
  if (typeof date === "string") {
    const mts = date.match(/(\/Date(\d+)\/)/);
    if (mts && mts.length >= 3) {
      date = parseInt(mts[2]);
    }
  }
  date = new Date(date);
  return !(!date || date.toUTCString() === "Invalid Date");
}

/**
 * @description 获取日期的周数
 * @param {date | number | string} src - new Date() | new Date().getTime() | '2020-10-10'
 * @returns {number}
 */
export function getWeekNumber(src) {
  if (!checkDate(src)) return undefined;
  const date = new Date(src.getTime());
  date.setHours(0, 0, 0, 0);
  // Thursday in current week decides the year.
  date.setDate(date.getDate() + 3 - ((date.getDay() + 6) % 7));
  // January 4 is always in week 1.
  const week1 = new Date(date.getFullYear(), 0, 4);
  // Adjust to Thursday in week 1 and count number of weeks from date to week 1.
  // Rounding should be fine for Daylight Saving Time. Its shift should never be more than 12 hours.
  return (
    1 +
    Math.round(
      ((date.getTime() - week1.getTime()) / 86400000 -
        3 +
        ((week1.getDay() + 6) % 7)) /
        7
    )
  );
}

/**
 * @description 对日期进行格式化，
 * @requires utils/index#.checkDate
 * @param {date | number | string} date - new Date() | new Date().getTime() | '2020-10-10'
 * @param {string} format - 进行格式化的模式字符串 yyyy-MM-dd hh:mm:ss:SS q W
 * @example
 * // format = 'yyyy-MM-dd' => '2021-10-10'
 *  支持的模式字母有：
 *  y:年,
 *  M:年中的月份(1-12),
 *  W:年中的第几周,
 *  d:月份中的天(1-31),
 *  h:小时(0-23),
 *  m:分(0-59),
 *  s:秒(0-59),
 *  S:毫秒(0-999),
 *  q:季度(1-4)
 * @returns {string}
 */
export function dateFormat(date, format) {
  if (!checkDate(date)) {
    return "--";
  }
  date = new Date(date);
  const map = {
    M: date.getMonth() + 1, // 月份
    W: getWeekNumber(date), // 周
    d: date.getDate(), // 日
    h: date.getHours(), // 小时
    m: date.getMinutes(), // 分
    s: date.getSeconds(), // 秒
    q: Math.floor((date.getMonth() + 3) / 3), // 季度
    S: date.getMilliseconds(), // 毫秒
  };

  return format.replace(/([yMWdhmsqS])+/g, (all, t) => {
    let v = map[t];
    if (v !== undefined) {
      if (all.length > 1) {
        v = "0" + v;
        v = v.substr(v.length - 2);
      }
      return v;
    } else if (t === "y") {
      return (date.getFullYear() + "").substr(4 - all.length);
    }
    return all;
  });
}

/**
 * @description 跳转旧企业端页面
 * @param {string} hashUrl hash 短路径，旧项目路由中截取hash路径中的去除参数的部分，如 #/usercenter/staff/company=10027&farm=12996 截取 /usercenter/staff
 * hashUrl 格式其实是旧企业端项目中，"/页面文件夹名/页面名"
 */

export function windowHref(hashUrl, params = {}) {
  if (typeof hashUrl != "string") {
    return;
  }
  // FARMINFO 可能在登录态缺失时为空，避免直接取属性报错
  const farmInfo = getStorage("FARMINFO") || {};
  const companyId = params.companyId ? params.companyId : farmInfo.companyId;
  const farmId = params.farmId ? params.farmId : farmInfo.farmId;

  let keys = Object.keys(params);
  let paramsUrl = "";
  if (keys.length) {
    //路径有params，传参就取params中的值
    for (let v in keys) {
      if (keys[v] === "companyId") {
        paramsUrl = paramsUrl + "company" + "=" + params[keys[v]];
      } else if (keys[v] === "farmId") {
        paramsUrl = paramsUrl + "farm" + "=" + params[keys[v]];
      } else {
        paramsUrl = paramsUrl + keys[v] + "=" + params[keys[v]];
      }
      if (v < keys.length - 1) {
        paramsUrl = paramsUrl + "&";
      }
    }
  } else {
    //无params
    paramsUrl = `company=${companyId}&farm=${farmId}`;
  }
  // 获取当前环境的源地址
  const origin = window.location.origin;
  // 判断 hashUrl 格式是否符合要求，不符合时兼容处理下
  const s = hashUrl.startsWith("/");
  const e = hashUrl.endsWith("/");
  const symbol = s ? "/index.html#" : "/index.html#/";
  const paramsStr = e ? paramsUrl : `/${paramsUrl}`;

  const href = origin + symbol + hashUrl + paramsStr;
  window.open(href, "_self");
}

/***
 * @description 截取指定字符长度的字符串（中文占两个字符，英文占一个）
 * @param {string} str 要截取的源字符串
 * @param {number}  count 指定的字数
 */
export const cutStrByCharLen = (str, count) => {
  if (typeof str !== "string") {
    return;
  }
  let result = "";
  // 原字符串长度
  const strlen = str.length;
  // 原字符串总的字符长度
  const chrlen = getStrCharLen(str);
  // 假设字符全是汉字占两个字符的，最大的字符长度
  const maxChrlen = count * 2;
  if (chrlen <= maxChrlen) {
    return str;
  }
  for (let i = 0, j = 0; i < strlen; i++) {
    var chr = str.charAt(i);
    // eslint-disable-next-line no-control-regex
    if (/[\x00-\xff]/.test(chr)) {
      j++;
    } else {
      j += 2;
    }
    if (j <= maxChrlen) {
      result += chr;
    } else {
      return result;
    }
  }
};

/***
 * @description 判断，返回字符串总的字符长度（注意返回的是字符长度，如果用于比较字数，需要把字数转换为字符长度，比如最多10个汉字，最大最大长度就是20）
 * @param {string} str 要判断的字符串
 */
export function getStrCharLen(str) {
  if (typeof str !== "string") {
    return;
  }
  // eslint-disable-next-line no-control-regex
  return str.replace(/[^\x00-\xff]/g, "**").length;
}

/**
 * @description: Date原型扩展
 * @param {string} format 如："yyyy-MM-dd hh:mm:ss"、"yyyy.MM.dd"
 * @return: string 日期字符串
 */
Date.prototype.format = function (format) {
  var o = {
    "M+": this.getMonth() + 1, //month
    "d+": this.getDate(), //day
    "h+": this.getHours(), //hour
    "m+": this.getMinutes(), //minute
    "s+": this.getSeconds(), //second
    "q+": Math.floor((this.getMonth() + 3) / 3), //quarter
    S: this.getMilliseconds(), //millisecond
  };
  if (/(y+)/i.test(format)) {
    format = format.replace(
      RegExp.$1,
      (this.getFullYear() + "").substr(4 - RegExp.$1.length)
    );
  }
  for (var k in o) {
    if (new RegExp("(" + k + ")").test(format)) {
      format = format.replace(
        RegExp.$1,
        RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length)
      );
    }
  }
  return format;
};

/**
 * @description: 日期格式处理
 * @param {number} timestamp 时间戳
 * @param {string} formatStr 时间格式
 * @return: string，如：2021-01-01
 */
export function formatDate(timestamp, formatStr) {
  if (!checkDate(timestamp)) {
    return "--";
  }
  return new Date(timestamp).format(formatStr);
}

/**
 * @description: 名字改变头像颜色
 * @param {string} str 名称字符串
 * @return: 返回数组或布尔值
 */
export function todealName(str) {
  str = str.replace(/\s/g, "");
  var colors = [
    "#648EC3",
    "#8364C3",
    "#C36468",
    "#64B0C3",
    "#64B0C3",
    "#C38664",
  ];
  if (typeof str == "string") {
    let color = getcolors(str);
    let strname = getname(str);
    return [color, strname];
  } else if (typeof str == "number") {
    let color = getcolors(String(str));
    let strname = getname(str);
    return [color, strname];
  } else {
    return false;
  }

  //计算颜色
  function getcolors(str) {
    var num = "";
    var strarr = str.split("");
    for (var i = 0; i < strarr.length; i++) {
      num += String(strarr[i].charCodeAt());
    }
    return colors[parseInt(num) % colors.length];
  }

  //计算字符串
  function getname(str) {
    str = str.toUpperCase();
    if (str.length > 0) {
      if (str.length < 2) {
        return str;
      } else {
        if (
          str.match(/[\u4e00-\u9fa5]/g) &&
          str.match(/[\u4e00-\u9fa5]/g).length == str.length
        ) {
          //全部中文
          return str.substring(str.length - 2, str.length);
        } else {
          return str.substring(0, 2);
        }
      }
    } else {
      return false;
    }
  }
}

/**
 * @description: 图片云服务器处理，视频返回截图
 * @param {path} path 图片链接，支持阿里云，华为云图片链接
 * @param {number} width 图片宽
 * @param {number} height 图片高
 * @param {boolean} keepFormat 是否保存原图片扩展名
 * @return {string} 指定大小的处理后图片地址
 */
export function setImgUrl(
  path = "",
  width = 100,
  height = 100,
  keepFormat = false
) {
  const isVideoPath = /mp4/.test(path); // 是否为视频
  const isAliOss = /.aliyuncs.com/.test(path); // 是否为阿里云资源
  const isHwObs = /.obs.cn-/.test(path); // 是否为华为云资源
  // 视频截帧
  if (isVideoPath) {
    if (isAliOss)
      return `${path}?x-oss-process=video/snapshot,t_0,f_jpg,w_${width},h_${height},ar_auto`;
    return require("@/assets/images/bs/farm-detail/poster.jpg"); // 视频默认图
  }
  // 阿里云 oss
  if (isAliOss) {
    if (path.indexOf("x-oss-process=image") !== -1) return path;
    const urlParams = [
      "?x-oss-process=image/resize",
      width && `w_${Math.ceil(width)}`,
      height && `h_${Math.ceil(height)}`,
      width && height && "m_fill",
      "/auto-orient,1/quality,q_100/sharpen,80/format",
      keepFormat
        ? /.png/.test(path)
          ? "png"
          : /.gif/.test(path)
          ? "gif"
          : "jpg"
        : "jpg",
    ]
      .filter((content) => content)
      .join(",");
    return path + urlParams;
  }
  // 华为云
  if (isHwObs) {
    if (path.indexOf("x-image-process=image") !== -1) return path;
    const urlParams = [
      "?x-image-process=image/resize",
      width && `w_${Math.ceil(width)}`,
      height && `h_${Math.ceil(height)}`,
      width && height && "m_fixed",
      "/format",
      keepFormat
        ? /.png/.test(path)
          ? "png"
          : /.gif/.test(path)
          ? "gif"
          : "jpg"
        : "jpg",
    ]
      .filter((content) => content)
      .join(",");
    return path + urlParams;
  }
  return path;
}

/**
 * @description: 图片云服务器圆角处理
 * @param {path} path 图片链接，支持阿里云，华为云图片链接
 * @param {number} radius 圆形图片直径
 * @return: 指定大小的处理后图片地址
 */
export function setRoundedImgUrl(path = "", radius = 100) {
  const isVideoPath = /mp4/.test(path); // 是否为视频
  const isAliOss = /.aliyuncs.com/.test(path); // 是否为阿里云资源
  const isHwObs = /.obs.cn-/.test(path); // 是否为华为云资源
  if (isVideoPath) return path;
  if (isAliOss) {
    return (
      path +
      "?x-oss-process=image/resize,m_fill,h_" +
      radius +
      ",w_" +
      radius +
      "/rounded-corners,r_" +
      radius +
      "/format,png"
    );
  }
  if (isHwObs) {
    // 输入是jpg 圆以外是白色
    return (
      path +
      "?x-image-process=image/resize,m_fixed,h_" +
      radius +
      ",w_" +
      radius +
      ",image/circle,r_" +
      radius +
      "/format,png"
    );
  }
  return path;
}

/**
 * @description 映射本（上、下）周，21天的中文表达
 * @param {date | number | string} date - new Date() | new Date().getTime() | '2020-10-10'
 * @param {string} [prefixFormat] - 仅支持 yyyy-MM-dd
 * @param {string} [suffixFormat] - 仅支持 hh:mm:ss:SS q
 * @returns {string}
 */
export function dateFormatMapping(date, prefixFormat, suffixFormat) {
  const curTimestamp = new Date().getTime();
  const _date = new Date(curTimestamp).getDate();
  const day = new Date(curTimestamp).getDay();
  // const year = new Date(curTimestamp).getFullYear();
  const mondayTimestamp = new Date(curTimestamp).setDate(
    _date - (day ? day - 1 : 6)
  );
  const weekZh = ["周一", "周二", "周三", "周四", "周五", "周六", "周日"];
  const prevPrefix = "上";
  const nextPrefix = "下";
  const mapping = {
    "+0": "今天",
    "-1": "昨天",
    "-2": "前天",
    "+1": "明天",
    "+2": "后天",
  };
  const mappingFormat = {};
  const suffix = suffixFormat ? dateFormat(date, suffixFormat) : "";
  for (const [key, d] of weekZh.entries()) {
    const mondayDate = new Date(mondayTimestamp).getDate();
    mappingFormat[
      dateFormat(
        new Date(mondayTimestamp).setDate(mondayDate - 7 + key),
        prefixFormat
      )
    ] = `${prevPrefix}${d}`;
    mappingFormat[
      dateFormat(
        new Date(mondayTimestamp).setDate(mondayDate + key),
        prefixFormat
      )
    ] = `${d}`;
    mappingFormat[
      dateFormat(
        new Date(mondayTimestamp).setDate(mondayDate + 7 + key),
        prefixFormat
      )
    ] = `${nextPrefix}${d}`;
  }
  // 特殊时间覆盖原有时间
  for (const [key, d] of Object.entries(mapping)) {
    mappingFormat[
      dateFormat(
        new Date(curTimestamp).setDate(_date + parseInt(key)),
        prefixFormat
      )
    ] = d;
  }
  // =1 取映射集合中的中文表达
  // =2 直接使用时间格式同年去年份
  return (
    (mappingFormat[dateFormat(date, prefixFormat)] ||
      // 正则用于去除当前年
      dateFormat(date, prefixFormat)) + suffix
  );
}

/**
 * @description 最大保留的位数
 * @param {number | string} value=0
 * @param {number} [places=2] - 精确浮点位
 * @returns {number}
 */
export function maxDecimalPlaces(value = 0, places = 2) {
  if (Number.isNaN(value) || value === undefined || value === null)
    return value;
  if (!Number.isInteger(value)) {
    value = String(value);
    if (value.split(".")[1].length > places) {
      value = Math.round(value * Math.pow(10, places)) / Math.pow(10, places);
    }
  }
  return parseFloat(value);
}

/**
 * @description 面积统一转成亩
 * @param {number} value - 面积
 * @param {number} [unitCode=1] - 1-值不改动 2-分 3-平方米
 * @returns {number}
 */
export function area2Mu(value, unitCode) {
  switch (unitCode) {
    case 3:
      return maxDecimalPlaces(value * 0.0015);
    case 2:
      return maxDecimalPlaces(value * 0.1);
    case 1:
    default:
      return maxDecimalPlaces(value);
  }
}

/**
 * 开始时间到结束时间的区间
 * @param startTime
 * @param howMonth
 * @param format
 * @returns {Array}
 */
export const getIntervalTime = ({
  startTime = new Date().getTime(),
  howMonth = 12,
  format = "yyyy-MM-dd",
} = {}) => {
  const sD = new Date(startTime);
  let sMonth = new Date(sD.setDate(1)).getMonth();
  const monthFormat = [];
  for (let i = 0; i < howMonth; i++) {
    monthFormat.push(dateFormat(new Date(sD).setMonth(sMonth++), format));
  }
  return monthFormat;
};
/**
 * @description: 获取页面search参数
 * @param {type} 无
 * @return: 无
 */
export const getPageParams = () => {
  let url = document.location.toString();
  let arrObj = url.split("?");
  let params = Object.create(null);
  if (arrObj.length > 1) {
    arrObj = arrObj[1].split("&");
    arrObj.forEach((item) => {
      item = item.split("=");
      params[item[0]] = item[1];
    });
  }
  return params;
};

/**
 * @description: base64编码对象转blob二进制
 * @param {string} base64Data base-64编码的字符串
 * @return: blob
 */
export const convertImgDataToBlob = (base64Data) => {
  var format = "image/jpeg";
  var base64 = base64Data;
  var code = window.atob(base64.split(",")[1]);
  var aBuffer = new window.ArrayBuffer(code.length);
  var uBuffer = new window.Uint8Array(aBuffer);
  for (var i = 0; i < code.length; i++) {
    uBuffer[i] = code.charCodeAt(i) & 0xff;
  }
  var blob = null;
  try {
    blob = new Blob([uBuffer], { type: format });
  } catch (e) {
    window.BlobBuilder =
      window.BlobBuilder ||
      window.WebKitBlobBuilder ||
      window.MozBlobBuilder ||
      window.MSBlobBuilder;
    if (e.name == "TypeError" && window.BlobBuilder) {
      var bb = new window.BlobBuilder();
      bb.append(uBuffer.buffer);
      blob = bb.getBlob("image/jpeg");
    } else if (e.name == "InvalidStateError") {
      blob = new Blob([aBuffer], { type: format });
    }
  }
  return blob;
};

/**
 * @description 防抖 注释：在高频率事件触发时，只保留最后一次事件
 * @param {function} fn - 事件函数
 * @param {number} [delay=300] - 延迟时间 单位：毫秒
 * @returns {(function(): void)}
 */
export const debounce = (fn, delay = 300) => {
  let timeout = null;
  return function () {
    if (timeout) clearTimeout(timeout);
    timeout = setTimeout(() => {
      fn.apply(this, arguments);
      timeout = null;
    }, delay);
  };
};

/**
 * 取 APICloud 容器对象（window.api）。
 *
 * APICloud 用 `api.openFrame` / `api.openWin` 打开页面时，会把 `api` 注入到该 webview 的
 * JS 上下文（`api.systemType` 等基础属性在页面脚本执行前即可读）。
 * 另兼容「容器把内容放在 iframe 里」的情况：此时当前 window 没有 api，需向父窗口取，
 * 跨域访问会抛错，故用 try/catch 兜住。
 * @returns {Object|null}
 */
function getApiCloud() {
  const pick = (w) => {
    try {
      const api = w && w.api;
      return api && typeof api === "object" ? api : null;
    } catch (e) {
      return null; // 跨域 iframe：拿不到父窗口
    }
  };
  return pick(window) || pick(window.top) || pick(window.parent) || null;
}

/**
 * URL 上的端别显式声明：`?platform=h5` / `?platform=pc`（也兼容写在 hash 里）。
 * 供 APICloud 侧（或联调）**强制**指定端别 —— 不依赖任何环境嗅探，最确定。
 * @returns {""|"h5"|"pc"}
 */
function getPlatformOverride() {
  const raw = `${window.location.search || ""}${window.location.hash || ""}`;
  const m = /[?&]platform=(h5|pc)(?![a-z0-9])/i.exec(raw);
  return m ? m[1].toLowerCase() : "";
}

/**
 * 是否运行在「神农口袋 App」容器内（APICloud 打包的 App）。
 *
 * 依据 App 端实际 UA 标记判断（由 App 团队提供）：
 *   - `vue_apicloud`   ：Vue 版 APICloud 容器
 *   - `yonyoucloud_app`：用友云 App
 * 用 includes 等价于 `indexOf(...) !== -1`，比示例里的 `> 0` 更严谨
 * （`> 0` 会漏掉恰好位于 UA 开头的情况）。
 *
 * 用 UA 而非 `api.systemType` 的原因：UA 在页面脚本执行前就已确定，
 * **不受容器注入时机影响**，不会出现「首帧误判成 PC 再自行纠正」的闪现。
 * @returns {boolean}
 */
export const isApp = () => {
  const ua = navigator.userAgent || "";
  return ua.includes("vue_apicloud") || ua.includes("yonyoucloud_app");
};

/**
 * 是否移动端（H5）
 *
 * 判定顺序（越靠前越权威，任一命中即返回）：
 *  1. URL 显式声明 `platform=h5|pc` —— 调用方可控，最确定；
 *  2. **App 容器**：UA 含 `vue_apicloud` / `yonyoucloud_app`（见 isApp）；
 *  3. `api.systemType` 为 ios / android —— 作为 UA 判断的补充；
 *  4. UA 含移动端特征；
 *  5. 视口宽度 ≤ 767（与页面样式断点同阈值，避免「样式按 H5、JS 判 PC」）。
 * @returns {boolean}
 */
export const isMobile = () => {
  const override = getPlatformOverride();
  if (override) return override === "h5";

  // App 容器内：页面即 H5 形态（UA 判断，无注入时机问题）
  if (isApp()) return true;

  const api = getApiCloud();
  if (api) {
    const type = String(api.systemType || "").toLowerCase();
    if (type === "ios" || type === "android") return true;
    // 在 openFrame 内（有 frameName）说明是嵌入 App 的页面，同样按 H5 处理
    if (api.frameName) return true;
  }

  const ua = navigator.userAgent || "";
  const mobileUa =
    /Android|iPhone|iPod|iPad|Windows Phone|HarmonyOS|APICloud|Mobile/i.test(
      ua
    );
  if (mobileUa) return true;
  return window.innerWidth <= 767;
};

/**
 * APICloud 环境就绪后的回调（非 APICloud 环境静默跳过）。
 *
 * 少数情况下 `api` 注入晚于组件创建（页面脚本先于容器注入执行），
 * 此时首帧会误判成 PC —— 头部不隐藏、且会要求登录。
 * 组件可在 mounted 里用本方法再校正一次。
 * `api.systemType` 通常已可用，此时不会再有 apiready，故立即执行一次兜底。
 * @param {Function} fn 就绪后执行
 */
export const onApiReady = (fn) => {
  const api = getApiCloud();
  if (!api) return;
  if (typeof api.systemType === "string" && api.systemType) {
    fn(); // 已就绪
    return;
  }
  if (typeof api.addEventListener === "function") {
    try {
      api.addEventListener({ name: "apiready" }, fn);
    } catch (e) {
      /* 忽略：不支持事件时由调用方自行兜底 */
    }
  }
};

/**全局固定数据 */
export const globalObj = {
  saleTowards: {
    agri: [
      {
        name: "本地",
        value: 1,
        childs: [
          { name: "田头销售", value: 10 },
          { name: "美团买菜", value: 17 },
          { name: "叮咚买菜", value: 18 },
          { name: "盒马鲜生", value: 19 },
          { name: "多多买菜", value: 20 },
          { name: "大润发", value: 21 },
          { name: "超市", value: 11 },
          { name: "企业事业单位", value: 12 },
          { name: "菜场", value: 13 },
          { name: "批发市场", value: 14 },
          { name: "粮管所", value: 15 },
          { name: "其他", value: 16 },
        ],
      },
      {
        name: "外地",
        value: 2,
        childs: [],
      },
    ],
    forestry: [
      {
        name: "本地",
        value: 1,
        childs: [
          { name: "田头销售", value: 10 },
          { name: "超市", value: 11 },
          { name: "企业事业单位", value: 12 },
          { name: "批发市场", value: 14 },
          { name: "其他", value: 16 },
        ],
      },
      {
        name: "外地",
        value: 2,
        childs: [],
      },
    ],
    animal: [
      {
        name: "本地",
        value: 1,
        childs: [
          { name: "田头销售", value: 10 },
          { name: "超市", value: 11 },
          { name: "企业事业单位", value: 12 },
          { name: "批发市场", value: 14 },
          { name: "其他", value: 16 },
        ],
      },
      {
        name: "外地",
        value: 2,
        childs: [],
      },
    ],
    fishery: [
      {
        name: "本地",
        value: 1,
        childs: [
          { name: "田头销售", value: 10 },
          { name: "超市", value: 11 },
          { name: "企业事业单位", value: 12 },
          { name: "批发市场", value: 14 },
          { name: "其他", value: 16 },
        ],
      },
      {
        name: "外地",
        value: 2,
        childs: [],
      },
    ],
  },
};

export const REG_TEL =
  /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;

/**
 * @description 小数相加 保留精度
 * @param [num] 小数
 */
export const addFloatNumber = (a, b) => {
  let tmpLena = a.toString().split(".")[1]?.length || 0;
  let tmpLenb = b.toString().split(".")[1]?.length || 0;
  let initFloatLen = tmpLena > tmpLenb ? tmpLena : tmpLenb;
  const m = Math.pow(10, initFloatLen);
  return (a * m + b * m) / m;
};
